import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api-client';

/**
 * TanStack Query defaults tuned for IOA:
 *  - 30s staleTime — most read endpoints (catalogue, journal, treasury)
 *    don't change every second; this avoids thundering re-fetches when
 *    components mount/unmount during navigation.
 *  - 5min gcTime — keep responses around long enough for "back" nav to
 *    feel instant (Vercel rule `client-swr-dedup`).
 *  - keepPreviousData on by default for paginated queries — set per
 *    query via `placeholderData: keepPreviousData` (constitution rule).
 *  - Don't retry on 4xx — those are programmer errors / business rule
 *    violations, retrying makes them worse. Retry once on 5xx + network.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
            return false;
          }
          return failureCount < 1;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
}
